<div class="rounded-2.5xl w-full text-center">
  <!-- Header -->
  <div class="p-8 border-gray-300 border-b">
    <h1 class="mb-2 text-xl md:text-3xl">Legal Terms</h1>
    <h2 class="text-sm md:text-base">{{ currentSection }}</h2>
  </div>
  <!-- <hr> -->
  <!-- Body -->
  <div class="p-4 text-left">
    <div class="h-[calc(100vh-20rem)] overflow-y-scroll">
      @switch (currentSection) {
        @case ('Legal Notice') {
          <app-legal-notice
            (displaySectionEmitter)="
              currentSection = $event
            "></app-legal-notice>
        }
        @case ('Privacy Policy') {
          <app-privacy-policy
            (displaySectionEmitter)="
              currentSection = $event
            "></app-privacy-policy>
        }
        @case ('Cookie Policy') {
          <app-cookie-policy></app-cookie-policy>
        }
        @default {
          <h4 class="font-normal">Select a section to view its content.</h4>
        }
      }
    </div>
    <div class="flex flex-wrap justify-center gap-2 mt-6 md:mt-12">
      <sdc-button
        class="gs-modal-btn--outline"
        className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="outline"
        (onClick)="close()">
        Close
      </sdc-button>
      <sdc-button
        class="gs-modal-btn--primary"
        className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="primary"
        (onClick)="currentSection = 'Legal Notice'">
        Legal Notice
      </sdc-button>
      <sdc-button
        class="gs-modal-btn--primary"
        className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="primary"
        (onClick)="currentSection = 'Privacy Policy'">
        Privacy Policy
      </sdc-button>
      <sdc-button
        class="gs-modal-btn--primary"
        className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="primary"
        (onClick)="currentSection = 'Cookie Policy'">
        Cookie Policy
      </sdc-button>
    </div>
  </div>
</div>
